export default () => {
  const show = function (elem) {
    const getHeight = function () {
      elem.style.display = 'block';
      const height = `${elem.scrollHeight}px`;
      elem.style.display = '';
      return height;
    };

    const height = getHeight();

    elem.classList.add('is-visible');
    elem.style.height = height;

    window.setTimeout(() => {
      elem.style.height = '';
    }, 350);
  };

  const hide = function (elem) {
    elem.style.height = `${elem.scrollHeight}px`;
    elem.style.heightOffset = -Math.abs(elem.scrollHeight);

    console.log(elem.style.heightOffset);

    window.setTimeout(() => {
      elem.style.height = '0';
    }, 1);

    window.setTimeout(() => {
      elem.classList.remove('is-visible');
    }, 350);

    window.scrollBy(0, elem.style.heightOffset);
  };

  const toggle = function (elem, timing) {
    if (elem.classList.contains('is-visible')) {
      hide(elem);
      return;
    }

    show(elem);
  };

  // const height = document.getElementById("pIngredients").offsetHeight;
  // console.log(height);

  document.addEventListener(
    'click',
    (event) => {
      if (
        !event.target.classList.contains(
          'product-ingredients__read-more-trigger',
        )
      ) {
        return;
      }

      event.preventDefault();

      const content = document.querySelector(event.target.hash);

      if (!content) {
        return;
      }
      toggle(content);
    },
    false,
  );
};
